import "es6-shim";
import "../../styles/Main.css";
import "../../styles/Buttons.css";
import * as React from 'react';
import TimerManager from "../../services/TimerManager";
import { useEffect } from "react";
import { IIntroductionProps } from "./Types";
import AcquireHealthCardNumber from "../AcquireHealthCardNumber/AcquireHealthCardNumber.container";
import { ACQUIRING_MODE } from "../../store/AcquireHealthCardNumber/type";

export const Introduction = (props: IIntroductionProps) => {
    useEffect(() => {
        TimerManager.stopInactivityListener();
        props.resetStoreData();
        if (!props.isUserAuthenticated) {
            props.returnToLoginPage();
        }
    }, []);

    return (
        <div>
            <div className="row">
                <div className="col-md-12 header text-center">
                    <div>
                        <h1 className="clinic-header" style={{ fontSize: "40px", marginLeft: "0", marginRight: "0" }}>
                            {props.clinicName.toUpperCase()}
                        </h1>
                        <h2 className="clinic-header" style={{ fontSize: "30px", marginLeft: "0", marginRight: "0" }}>
                            {props.text.messagesInstructions.WelcomeMessage.toUpperCase()}
                        </h2>
                    </div>
                </div>
            </div>
            {
                props.acquiringMethod !== ACQUIRING_MODE.MANUAL ?
                    <div
                        className="col-md-12"
                        style={{ fontSize: "30px", marginTop: "20px", minHeight: "250px" }}
                        dangerouslySetInnerHTML={{ __html: props.introductionMessages[props.lang] }}
                    />
                    :
                    <div className="text-center">
                        <h1 className="title-instruction">{props.text.messagesInstructions.ManualInputInstructions}</h1>
                    </div>
            }
            <AcquireHealthCardNumber />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Introduction/Introduction.component.tsx